/*
 * Created by TUTEHUB.
 * Copyright © TUTEHUB. All rights reserved.
 * ------------------------
 * Non-disclosure Terms
 * ------------------------
 * These codes are TUTEHUB's property, as the developer, such as employee, contractor, and intern, working for TUTEHUB cannot disclose, spread, copy, preserve, sell, and do other activities without the consent of TUTEHUB.
 * Technique Support: jobyme88.com
 */

import React from 'react'
import {Container} from 'react-bootstrap'


export default function SectionTitle(props) {


    return (
        <div className="course-title">
            
            <Container>
                <div className="up">
                    <div className="title">{props.title}</div>
                    {
                        props.tabs.map ((tab) => (
                            
                            <div className={`more ${props.tabKey === tab ? "active" : ""}`} onClick={() => props.setNewTabKey(tab)} >{tab}</div>
                        ))
                    }
                    <div className="more">See more</div>
                </div>
                <div className="des">{props.des}</div>
            </Container>
        </div>
    )
}
